import React, { useState } from 'react';
import {
  Card,
  TabPane,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  CardBody,
  Row,
} from 'reactstrap';
import { Colxx } from '../../components/common/CustomBootstrap';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import HotelCardSummary from './HotelCardSummary';
import HotelCardTopHotels from './HotelCardTopHotels';
import HotelCardTopChains from './HotelCardTopChains';
import HotelCardTopCities from './HotelCardTopCities';
import TypeAnalyticsLoading from './TypeAnalyticsLoading';

export default function HotelCard({ orders, reservations, parentLoading }) {
  const [activeTab, setActiveTab] = useState('summary');
  const { messages } = useIntl();

  if (parentLoading) {
    return (
      <Card className="mb-3">
        <CardHeader>
          <Nav tabs className="card-header-tabs justify-content-end">
            <div className="card-title flex-fill align-self-center pt-3">
              {messages['containers.dashboard.flight-card.title']}
            </div>
          </Nav>
        </CardHeader>

        <TabContent activeTab={'loading'}>
          <TabPane tabId="loading">
            <CardBody>
              <Row>
                <Colxx sm="12">
                  <TypeAnalyticsLoading />
                </Colxx>
              </Row>
            </CardBody>
          </TabPane>
        </TabContent>
      </Card>
    );
  }

  return (
    <Card className="mb-3">
      <CardHeader>
        <Nav tabs className="card-header-tabs justify-content-end">
          <div className="card-title flex-fill align-self-center pt-3">
            {messages['containers.dashboard.hotel-card.title']}
          </div>
          <NavItem>
            <NavLink
              to="#"
              location={{}}
              className={classnames({
                active: activeTab === 'summary',
                'nav-link': true,
              })}
              onClick={() => {
                setActiveTab('summary');
              }}
            >
              {messages['containers.dashboard.card.summary']}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to="#"
              location={{}}
              className={classnames({
                active: activeTab === 'top_hotel',
                'nav-link': true,
              })}
              onClick={() => {
                setActiveTab('top_hotel');
              }}
            >
              {messages['containers.dashboard.hotel-card.best-hotels']}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to="#"
              location={{}}
              className={classnames({
                active: activeTab === 'top_chain',
                'nav-link': true,
              })}
              onClick={() => {
                setActiveTab('top_chain');
              }}
            >
              {messages['containers.dashboard.hotel-card.best-companies']}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to="#"
              location={{}}
              className={classnames({
                active: activeTab === 'top_city',
                'nav-link': true,
              })}
              onClick={() => {
                setActiveTab('top_city');
              }}
            >
              {messages['containers.dashboard.hotel-card.best-cities']}
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>

      <TabContent activeTab={activeTab}>
        <TabPane tabId="summary">
          <HotelCardSummary orders={orders} reservations={reservations} />
        </TabPane>
        <TabPane tabId="top_hotel">
          <HotelCardTopHotels orders={orders} reservations={reservations} />
        </TabPane>
        <TabPane tabId="top_chain">
          <HotelCardTopChains orders={orders} reservations={reservations} />
        </TabPane>
        <TabPane tabId="top_city">
          <HotelCardTopCities orders={orders} reservations={reservations} />
        </TabPane>
      </TabContent>
    </Card>
  );
}
